import React, { useEffect, useState } from 'react'
import { GetData } from '../services/GetData'
import { PostData } from '../services/PostData'
import Swal from 'sweetalert2'
import BotonTabla from '../components/BotonTabla'

const PageGastos = () => {

       const [ListaGastos, setListaGastos] = useState([])
       const [Loading, setLoading] = useState(false)
       const [Refrest, setRefrest] = useState(false)
   
   
       const [idGasto , setIdGasto] = useState(0);
       const [FechaGasto, setFechaGasto] = useState('');
       const [gastosNum, setGastosNum] = useState('');
       const [idCategoria , setIdCategoria] = useState(0);
       const [idMetodo, setIdMetodo] = useState(0);
       const [Monto, setMonto] = useState(0);
       const [Descripcion, setDescripcion] = useState('');
       
     
       useEffect(() => {
           setLoading(true)
           GetData('gastos').then((result) => {
                   if (result.error === false){
                       setListaGastos(result.gastos)
                   }
                   setLoading(false)
           })
         
       }, [Refrest])
   
     const Modificar = (Cli) => {
           setIdGasto(Cli.id_cliente)
           setFechaGasto(Cli.nit_cli)
           setGastosNum(Cli.nombre_cli)
           setIdCategoria(Cli.telefono_cli)
           setIdMetodo(Cli.direccion_cli)
           setMonto(Cli.email_cli)
           setDescripcion(Cli.cod_cliente)
   
           const modal = document.getElementById('modalCliente');
   
           // Verificar si el modal existe antes de intentar abrirlo
           if (modal) {
             // Usar el método modal() para abrir el modal
             const modalInstancia = new window.bootstrap.Modal(modal);
             modalInstancia.show();
           }
     }  
   
     const NuevoGasto = () => {
           
           setIdGasto(0)
           setFechaGasto("")
           setGastosNum("")
           setIdCategoria("")
           setIdMetodo("")
           setMonto("")
           setDescripcion("")
   
           const modal = document.getElementById('modalCliente');
   
           // Verificar si el modal existe antes de intentar abrirlo
           if (modal) {
           // Usar el método modal() para abrir el modal
           const modalInstancia = new window.bootstrap.Modal(modal);
           modalInstancia.show();
           }
       }
   
       const Eliminar = (id_gasto, nombre) => {
   
         Swal.fire({
             title: '¿Estás seguro?',
             text: '¡No podrás revertir esto! ¿Estas seguro de eliminar a: ' + nombre + '?',
             icon: 'warning',
             showCancelButton: true,
             confirmButtonColor: '#3085d6',
             cancelButtonColor: '#d33',
             confirmButtonText: 'Sí, eliminarlo'
         }).then((result) => {
             if (result.isConfirmed) {
                
   
                 GetData('gastos/eliminar/' + id_gasto, null).then ((result) =>{
   
                     let responseJSON = result;
         
                     if (responseJSON.error === false){
                         Swal.fire({
                             title: 'Eliminado',
                             text: 'El gasto ha sido eliminado correctamente',
                             icon: 'success'
                         });
                         setRefrest(!Refrest);
                     }
                 })
                 // Muestra un mensaje de éxito después de eliminar
               
             }
         });
         
     }
   
       const validarFormulario = () => {
           if (
               Descripcion.trim() === '' ||
               Monto.trim() === ''
          
           ) {
             alert('Por favor, complete todos los campos requeridos.');
             return false;
           }
           return true;
         };
   
         const limpiarFormulario = () => {
            setIdGasto(0)
            setFechaGasto("")
            setGastosNum("")
            setIdCategoria("")
            setIdMetodo("")
            setMonto("")
            setDescripcion("")
       }
   
      const GuardarCliente = async () => {
               
               if (!validarFormulario()) {
                   return;
               }
               
               
               // Construcción del objeto proveedor
               const datos = {
                   id_gasto: idGasto,
                   id_categoria: idCategoria,
                   id_metodo: idMetodo,
                   monto: Monto,
                   descripcion: Descripcion,
                   fecha_gasto: FechaGasto
                   // Puedes agregar más campos aquí según tus necesidades
               };
   
               try {
                   //const response = await axios.post('URL_DE_TU_API/guardar_post', producto);
                   const response = await PostData('clientes/guardar', datos);
                   if (!response.error) {
                     Swal.fire({
                         title: 'Cargar Guardado',
                         text: 'Cliente guardado correctamente.',
                         icon:"success",
                         confirmButtonText: 'Aceptar'
                       });                  
                       limpiarFormulario()
                       setRefrest(!Refrest)
                     // Aquí puedes agregar cualquier otra acción como cerrar el modal, recargar la lista, etc.
                   } else {
                     Swal.fire({
                         title: 'Error al Guardar',
                         text: response.mensaje,
                         icon: 'error',
                         confirmButtonText: 'Aceptar'
                       });
                   }
                 } catch (error) {
                     Swal.fire({
                         title: 'Error al Guardar',
                         text: "Error al guardar el cliente: " + error,
                         icon: 'error',
                         confirmButtonText: 'Aceptar'
                       });
                   console.error('Error al guardar el cliente:', error);
                   
                 }
      } 
   
    return (
       <>
        <section className='section dashboard'>
                    <div className="card">
                    <div className='card-header'>Gastos</div>    
                    <div className="card-body pb-0">


                    <div className='row'>                          
                            
                            <div className='col-md-2'>
                                <button type="button" className="btn btn-primary btn-sm mt-4 ml-2" onClick={NuevoGasto} >
                                    <i className="bi bi-person-plus"></i> Novo Gasto
                                </button>
                            </div>
                            <div className='col-md-2 mt-4'>
                                <span className='label'> N°:</span> <span className='texto'>{ListaGastos.length}</span>                                  
                            </div>
                    </div>    

                    <div className='row'>
                            

                    </div>

                    {Loading && 
                    <div class="progress mt-3">
                        <div class="progress-bar progress-bar-striped bg-info progress-bar-animated" role="progressbar" style={{width : '100%'}} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>      
                    }      
                     <div className="table-responsive">
                    <table class="table table-striped  mt-2">
                        <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Fecha</th>
                            <th scope="col">Grupo</th>
                            <th scope="col">Descrição</th>
                            <th scope="col">Valor</th>
                            <th scope="col">Método</th>
                            <th scope="col">Cat</th>
                            <th scope="col">Op</th>
                        </tr>
                        </thead>
                        <tbody>
                        {ListaGastos.map((gast, index) => 
                        <tr index={gast.id_gasto}>
                            <th scope="row">{index+1}</th>
                            <th scope="row">{gast.fecha_gasto}</th>
                            <td>{gast.gastos_num}</td>
                            <td align='center'>{gast.descripcion}</td>
                            <td align='center'>{gast.monto}</td>
                            <td align='center'>{gast.id_metodo}</td>
                            <td align='center'>{gast.id_categoria}</td>
                            <td>
                              <BotonTabla icono='lapiz.png' titulo='Modificar' evento={()=>Modificar(gast)} />
                              <BotonTabla icono='borrar.png' titulo='Eliminar' evento={()=>Eliminar(gast.id_gasto, gast.gastos_num)} />
                            </td>
                        </tr>
                        )}    
                        
                        </tbody>
                    </table>
                    </div>
                    </div>
                </div>
            </section>    


          
    
    </>
    );
};

export default PageGastos;